/**
 * ver 0.1
 * author jack
 */
import React from 'react'
import styled from 'styled-components';

class LoginLayer extends React.Component {
    fontSize = {
        'fontSize': '17px'
    }
    width = {
        'width': 'auto'
    }

    componentDidMount() {
        this.onPopupStyle(false)
    }

    componentWillUnmount() {
        this.onPopupStyle(true)
    }

    onPopupStyle = (state) => {
        document.querySelector('#header').style.opacity = state ? 1 : 0
        if (this.props.pageType === 1) { // 상품 비교 새창일 떄
            document.body.style.overflow = 'hidden'
        } else {
            document.body.style.overflow = state ? 'visible' : 'hidden'
        }
    }

    goLogin() {
        window.location.href = process.env.REACT_APP_SSO_URL
    }
    render() {
        return (
            <BackDrop>
                <WrapperLayer>
                    <WrapperCloseIcon>
                        <CloseIcon className="icon-close" onClick={this.props.onClose}></CloseIcon>
                    </WrapperCloseIcon>
                    <WrapperTitleText>
                        <span><b>로그인이</b> 필요한 서비스 입니다.</span>
                    </WrapperTitleText>
                    <WrapperButton>
                        <LeftButton onClick={this.props.onClose}>
                            닫기
                        </LeftButton>
                        <RightButton onClick={this.goLogin}>
                            로그인 하러가기
                        </RightButton>
                    </WrapperButton>
                </WrapperLayer>
            </BackDrop>
        )
    }
}

const BackDrop = styled.div`
        height: 100%;
        left: 0;
        min-width: 950px;
        position: fixed;
        text-align: center;
        top: 0;
        width: 100%;
        z-index: 220;
        background-color: rgba(0, 0, 0, 0.75);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        font-family: 'Noto Sans KR', "나눔고딕", 'Nanum Gothic', "맑은고딕", 'Malgun Gothic', ‘Apple SD Gothic Neo’, "돋움", dotum, "굴림", gulim, sans-serif;
`

const WrapperLayer = styled.div`
    box-sizing: border-box;
    width: 374px;
    min-height: 187px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    position: relative;
    padding: 14px 12px;
    border: 2px solid #333333;
`

const WrapperCloseIcon = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
`

const CloseIcon = styled.button`
    font-size: 31px;
    color: #418DED;
    :hover {
        color: #005796;
    }
`

const WrapperTitleText = styled.div`
    width: 100%;
    font-weight: bold;
    font-size: 22px;
    margin-top: 17px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    span {
        width: 100%;
        color: #333333;
        font-size: 22px;
        line-height: 28px;
        text-align: center;

        b {
            color: #3281ED;
        }
    }
`

const WrapperButton = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-top: 21px;
    padding: 0 10px;
`

const LeftButton = styled.button`
    &&{
        width: 156px;
        height: 40px;
        border: 2px solid #418DED;
        text-align: center;
        color: #418DED;
        font-size: 16px;
        font-weight: bold;
        line-height: 21px;
        background-color: #fff;
        margin-right: 10px;
        :hover{
            background-color: #F6F6F6;
        }
    }
`

const RightButton = styled.button`
    &&{
        width: 156px;
        height: 40px;
        border: 2px solid #418DED;
        text-align: center;
        color: #ffffff;
        font-size: 16px;
        font-weight: bold;
        line-height: 21px;
        background-color: #418DED;
        :hover{
            background-color: #2D7EE4;
        }
    }
`

export default LoginLayer





// WEBPACK FOOTER //
// ./src/estimate_list/components/layer/loginLayer.js